import type Keycloak from 'keycloak-js';
import { environment } from '../../environments/environment';
import {
  KEYCLOAK_REFRESH_NETWORK_THRESHOLD_MS,
  recordKeycloakNetworkRefresh,
  recordKeycloakRefreshDeduped,
} from './keycloak-refresh-metrics';

/**
 * Garante uma única chamada de refresh em voo quando várias requisições HTTP
 * concorrem; delega ao `updateToken` nativo do keycloak-js.
 */
export function wrapKeycloakUpdateTokenSingleFlight(instance: Keycloak): void {
  const original = instance.updateToken.bind(instance) as (minValidity?: number) => Promise<boolean>;
  let inFlight: Promise<boolean> | null = null;
  const logSlow = environment.keycloak?.logRefreshDuration === true;

  instance.updateToken = (minValidity?: number) => {
    if (inFlight) {
      recordKeycloakRefreshDeduped();
      return inFlight;
    }
    const t0 = performance.now();
    inFlight = original(minValidity).finally(() => {
      inFlight = null;
      const ms = performance.now() - t0;
      if (ms >= KEYCLOAK_REFRESH_NETWORK_THRESHOLD_MS) {
        recordKeycloakNetworkRefresh(ms);
        if (logSlow) {
          console.debug(`[Keycloak] updateToken ${ms.toFixed(0)}ms (provável ida à rede)`);
        }
      }
    });
    return inFlight;
  };
}
